(function($) {
	
	var submenu = $('.current-menu-item').find('.sub-menu');

	submenu.find('a').click(function(event){
		event.preventDefault();
		var sec = $(this).attr('href');
		var top = $(sec).offset().top - 60;
		$("html:not(:animated),body:not(:animated)").animate({ scrollTop: top}, 500 );
	});

	$(window).scroll(function () {

		var currentScroll = $(window).scrollTop();

		submenu.find('a').each(function(){
			var sec = $(this).attr('href');
			var sec_top = $(sec).offset().top - 65;
			var sec_h =  $(sec).outerHeight();

			if(currentScroll >= sec_top && currentScroll < sec_top + sec_h) {
				$(this).addClass('current-sub');
			} else {
				$(this).removeClass('current-sub');
			}
		});

	});

})(jQuery);